import { TbBrandWhatsappFilled } from "react-icons/tb";

const WhatsAppChat = () => {
  return (
    <>
      <button
        className="fixed bottom-36 right-5 z-20 flex items-center justify-center
                   w-16 h-16 rounded-full shadow-lg transition-transform
                   hover:scale-110  "
      >
        <span
          className="absolute w-16 h-16 rounded-full border-4 border-green-400
                     opacity-70 animate-wave"
        />
        <span
          className="absolute w-16 h-16 rounded-full border-4 border-green-400
                     opacity-50 animate-wave animation-delay-600"
        />

        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://wa.me/7205648333?text=Hi%20there!%20I%20want%20to%20know%20details%20of%20your%20Course%20and%20eager%20to%20learn"
          className="relative z-10 flex items-center justify-center
                     w-full h-full text-green-500  "
        >
          <TbBrandWhatsappFilled className="w-14 h-14   " />
        </a>
      </button>

      <style jsx>{`
        @keyframes wave {
          0% {
            transform: scale(0.9);
            opacity: 0.7;
          }
          70% {
            transform: scale(1.6);
            opacity: 0;
          }
          100% {
            transform: scale(1.6);
            opacity: 0;
          }
        }

        .animate-wave {
          animation: wave 1.8s ease-out infinite;
        }

        .animation-delay-600 {
          animation-delay: 0.6s;
        }
      `}</style>
    </>
  );
};

export default WhatsAppChat;
